export const DIMENSION = {
  INCH: 100,
};

export const formatDimension = (value: number, dimension: keyof typeof DIMENSION = "INCH") =>
  value / DIMENSION[dimension];
